module.exports = function (paths) {
    const FURTHER_REF = paths.FURTHER_REF

    return {
        test: /\.jsx$/,
        // loaders: ['react-hot', 'babel-loader'],
        loader: FURTHER_REF + 'babel-loader',
        // FURTHER_REF + 'babel-loader',
        // loader: `${ FURTHER_REF }react-loader?presets[]=${ FURTHER_REF }react!${ FURTHER_REF }babel-preset-es2015?` + JSON.stringify({),
        exclude: /node_modules/,
        options: {
            plugins: [
            [FURTHER_REF + "babel-plugin-transform-decorators-legacy"],
            [FURTHER_REF + "babel-plugin-transform-react-jsx", { "pragma": "require('preact').h" }] ],
            presets: [
            [ FURTHER_REF + "babel-preset-preact" ],
            // [ FURTHER_REF + "babel-reset-preact/lib" ],
            [ FURTHER_REF + 'babel-preset-es2015', { loose: true, modules: false } ] ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/technologies/react.js